<div class="document-container">
    <div fxLayout="row" fxLayoutAlign="space-between center">
        <div style="font-weight: 500; font-size: 24px; line-height: 28px;color: #DEDEDE;">
            Total {{project.termFiles.length + project.documentFiles.length + dataSourceForEoi.length}} Documents
        </div>
    </div>
    <div style="margin-top:50px">
        <div class="title">Attachments for private documents</div>
        <ng-container *ngIf="dataSourceForTerms.length">
            <table mat-table [dataSource]="dataSourceForTerms" style="width: 100%">
                <ng-container matColumnDef="fileName">
                    <th mat-header-cell *matHeaderCellDef style="width: 30%">Document Name</th>
                    <td mat-cell *matCellDef="let element" fxLayoutAlign="start center">
                        <span (click)="openFile(element.fileName, 'term_files')"
                            class="filename">{{element.fileName}}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="uploadUser">
                    <th mat-header-cell *matHeaderCellDef style="width: 30%">Uploaded By</th>
                    <td mat-cell *matCellDef="let element">
                        <ng-container *ngIf="element.notes && element.notes.ext">
                            <div fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
                                <span class="uploader">{{ [element.notes.ext.firstName,
                                    element.notes.ext.lastName].join(' ') || '-'}}</span>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="!element.notes || !element.notes.ext">
                            <span class="uploader">-</span>
                        </ng-container>
                    </td>
                </ng-container>
                <ng-container matColumnDef="uploadTime">
                    <th mat-header-cell *matHeaderCellDef style="width: 30%">Uploaded At</th>
                    <td mat-cell *matCellDef="let element">
                        <ng-container *ngIf="element.notes && element.notes.createTime">
                            <span class="uploader">{{ element.notes.createTime | date:'HH:mm:ss d,LLL yyyy'}}</span>
                        </ng-container>
                        <ng-container *ngIf="!element.notes || !element.notes.createTime">
                            <span class="uploader">-</span>
                        </ng-container>
                    </td>
                </ng-container>
                <ng-container matColumnDef="action" stickyEnd>
                    <th mat-header-cell *matHeaderCellDef style="width: 10%"></th>
                    <td mat-cell *matCellDef="let element">
                        <img src="./assets/images/black/more.png" class="operate_image"
                            (click)="element.showBox=true" />
                        <div class="operate_box" *ngIf="element.showBox" (mouseleave)="element.showBox=false">
                            <img src="./assets/images/black/black_close.png" class="black_close"
                                (click)="element.showBox=false">
                            <div class="operate_text fz_14" (click)="openFile(element.fileName, 'term_files')">Download
                            </div>
                            <div class="operate_text fz_14" (click)="openDeleteConfirmDialog(element.id, 'terms')">
                                Delete</div>
                        </div>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumnsForTerms"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsForTerms;"></tr>
            </table>
        </ng-container>
        <ng-container *ngIf="dataSourceForTerms.length === 0 && isFiltered">
            <div
                style="display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 40px 0;">
                <p style="margin:4px;color: #dedede;font-size: 18px;font-weight: 600;">No matching items found</p>
                <p style="margin:4px;color: #dedede;opacity: 0.7;">Try adjusting your search or filter to find what are
                    you looking for.</p>
            </div>
        </ng-container>
        <ng-container *ngIf="dataSourceForTerms.length === 0 && !isFiltered">
            <div
                style="display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 40px 0;">
                <p style="margin:4px;color: #dedede;font-size: 18px;font-weight: 600;">No documents</p>
            </div>
        </ng-container>
    </div>
    <div style="margin-top: 40px">
        <div class="title">Attachments for public documents</div>
        <ng-container *ngIf="dataSourceForProject.length">
            <table mat-table [dataSource]="dataSourceForProject" style="width: 100%">
                <ng-container matColumnDef="fileName">
                    <th mat-header-cell *matHeaderCellDef style="width: 30%">Document Name</th>
                    <td mat-cell *matCellDef="let element" fxLayoutAlign="start center">
                        <span (click)="openFile(element.fileName, 'documents')"
                            class="filename">{{element.fileName}}</span>
                    </td>
                </ng-container>
                <ng-container matColumnDef="uploadUser">
                    <th mat-header-cell *matHeaderCellDef style="width: 30%">Uploaded By</th>
                    <td mat-cell *matCellDef="let element">
                        <ng-container *ngIf="element.notes && element.notes.ext">
                            <div fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="start center">
                                <span class="uploader">{{ [element.notes.ext.firstName,
                                    element.notes.ext.lastName].join(' ') || '-'}}</span>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="!element.notes || !element.notes.ext">
                            <span class="uploader">-</span>
                        </ng-container>
                    </td>
                </ng-container>
                <ng-container matColumnDef="uploadTime">
                    <th mat-header-cell *matHeaderCellDef style="width: 30%">Uploaded At</th>
                    <td mat-cell *matCellDef="let element">
                        <ng-container *ngIf="element.notes && element.notes.createTime">
                            <span class="uploader">{{ element.notes.createTime | date:'HH:mm:ss d,LLL yyyy'}}</span>
                        </ng-container>
                        <ng-container *ngIf="!element.notes || !element.notes.createTime">
                            <span class="uploader">-</span>
                        </ng-container>
                    </td>
                </ng-container>
                <ng-container matColumnDef="action" stickyEnd>
                    <th mat-header-cell *matHeaderCellDef style="width: 10%"></th>
                    <td mat-cell *matCellDef="let element">
                        <img src="./assets/images/black/more.png" class="operate_image"
                            (click)="element.showBox=true" />
                        <div class="operate_box" *ngIf="element.showBox" (mouseleave)="element.showBox=false">
                            <img src="./assets/images/black/black_close.png" class="black_close"
                                (click)="element.showBox=false">
                            <div class="operate_text fz_14" (click)="openFile(element.fileName, 'documents')">Download
                            </div>
                            <div class="operate_text fz_14" (click)="openDeleteConfirmDialog(element.id, 'project')">
                                Delete</div>
                        </div>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumnsForProject"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumnsForProject;"></tr>
            </table>
        </ng-container>
        <ng-container *ngIf="dataSourceForProject.length === 0 && isFiltered">
            <div
                style="display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 40px 0;">
                <p style="margin:4px;color: #dedede;font-size: 18px;font-weight: 600;">No matching items found</p>
                <p style="margin:4px;color: #dedede;opacity: 0.7;">Try adjusting your search or filter to find what are
                    you looking for.</p>
            </div>
        </ng-container>
        <ng-container *ngIf="dataSourceForProject.length === 0 && !isFiltered">
            <div
                style="display: flex; flex-direction: column; justify-content: center; align-items: center; padding: 40px 0;">
                <p style="margin:4px;color: #dedede;font-size: 18px;font-weight: 600;">No documents</p>
            </div>
        </ng-container>
    </div>
</div>